import { useCallback, useEffect, useState } from "react";

import { ErroAPI, api } from "./api.ts";

/**
 * Busca dados de um caminho da API.
 *
 * Sem auto-refresh de proposito: o heartbeat da frota e de seis horas, entao o
 * dado nao muda em trinta segundos, e uma pagina que se repinta sob o cursor e
 * hostil. Quem quiser atualizar recarrega -- e `recarregar` existe para as
 * acoes que mudam algo na propria tela.
 */
export function useDados<T>(caminho: string): {
  dados: T | null; erro: string; carregando: boolean; recarregar: () => void;
} {
  const [dados, setDados] = useState<T | null>(null);
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(true);

  const buscar = useCallback(() => {
    setCarregando(true);
    api.get<T>(caminho)
      .then((d) => { setDados(d); setErro(""); })
      .catch((e: unknown) => setErro(e instanceof ErroAPI ? e.message : "Falha ao carregar."))
      .finally(() => setCarregando(false));
  }, [caminho]);

  useEffect(buscar, [buscar]);

  return { dados, erro, carregando, recarregar: buscar };
}
